import Admin from 'containers/Admin/Admin'

export default function AdminPage() {
  return (
    <Admin />
  );
}
